export default __webpack_public_path__ + "static/media/033-honey jar.21bec6f2.svg";